import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Control, Errors, Form} from 'react-redux-form';
import {Button, Panel, Row} from 'react-bootstrap';
import {toast} from 'react-toastify';
import * as moment from 'moment';
import {Redirect} from 'react-router-dom';
import Title from '../../common/page-title';
import ToastMessage from '../../common/toast-message';
import {initialStates} from '../../../initialStates';
import DelinkForm from './delink-form';
import ConfirmationField from './confirmation-row';
import {delinkOutlet, getAdminOutlet, getCustomerNumbers} from '../../../actions/outlet';

import './delink.css';

class DelinkPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 1,
      formOutlet: {},
      form: initialStates.admin_delink
    };
    this.props.dispatch({type: 'CLEAR_OUTLET_DELINK'});

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleFinalize = this.handleFinalize.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if ((nextProps.match.params.id !== this.props.match.params.id && !nextProps.match.params.id) ||
      (nextProps.delink.delinked && !this.props.delink.delinked)) {
      this.setState({
        step: 1,
        formOutlet: {},
        form: initialStates.admin_delink
      });
      this.props.dispatch({type: 'CLEAR_OUTLET_DELINK'});
    }
  }

  componentWillMount() {
    const outletId = this.props.match.params.id;

    const {dispatch} = this.props;

    if (outletId !== undefined) {
      dispatch(getAdminOutlet(outletId)).then(() => {
        dispatch(getCustomerNumbers(this.props.outlet.attributes['customer-number'], '', false, true));
      });
    } else {
      dispatch(getCustomerNumbers('', '', false, true));
    }
  }

  handleBack() {
    this.setState({
      step: 1,
      form: initialStates.admin_delink,
      formOutlet: this.state.formOutlet
    });
  }

  handleOnInputChange = (inputValue) => {
    if (inputValue !== '') {
      const {dispatch} = this.props;
      dispatch(getCustomerNumbers(inputValue, '', false, true));
    }
    return inputValue;
  };

  handleSubmit(payLoad) {
    if (payLoad.outlet === '') {
      toast.error(<ToastMessage iconStyle="error" message="You have to select an outlet first!"/>);
      return false;
    }
    const formOutlet = this.props.outlets.find(e => e.id === payLoad.outlet);
    this.setState({
      step: 2,
      form: payLoad,
      formOutlet
    });
    this.forceUpdate();
    return true;
  }

  handleFinalize(payLoad) {
    this.props.dispatch(delinkOutlet(payLoad));
  }

  notFoundErrorRender() {
    const {errors} = this.props;
    if (typeof errors === 'string' && errors === 'Not Found') {
      toast.error(<ToastMessage iconStyle="error" message={`Outlet not found by id ${this.props.match.params.id}`}/>);

      return true;
    }
    return false;
  }

  confirm() {
    const data = this.state.form;
    const outlet = this.state.formOutlet;

    return (
      <Form model='deep.admin_delink' onSubmit={this.handleFinalize}>

        <Errors className="errors" model="deep.admin_delink"/>
        <Panel
          className="mg-top-20"
          footer={(
            <Row>
              <div className="col-md-6 text-left">
                <Button className="btn red-ghost-btn" onClick={this.handleBack}>
                  Back
                </Button>
              </div>
              <div className="col-md-6 text-right">
                <Button className="btn red-ghost-btn" type="submit">
                  Confirm and Process
                </Button>
              </div>
            </Row>
          )}
        >
          <ConfirmationField label="Outlet">
            {outlet.attributes.name}
          </ConfirmationField>
          <ConfirmationField
            label="User to be unlinked"
          >
            {outlet.attributes.owner ? outlet.attributes.owner.name : outlet.attributes.user}
          </ConfirmationField>
          <ConfirmationField label="Data of delinking">
            {moment(data.delink_date)
              .format('DD/MM/YYYY')}
          </ConfirmationField>
          <ConfirmationField label="Description">
            {data.delink_reason}
          </ConfirmationField>
          <ConfirmationField
            label="Notification to be sent?"
          >
            {data.supress_notification ? 'No' : 'Yes'}
          </ConfirmationField>
          <Control model=".outlet" required type="hidden" value={data.outlet}/>
          <Control model=".delink_date" required type="hidden" value={data.delink_date}/>
          <Control model=".delink_reason" required type="hidden" value={data.delink_reason}/>
          <Control model=".supress_notification" required type="hidden" value={data.supress_notification}/>
        </Panel>
      </Form>
    );
  }

  render() {
    if (this.notFoundErrorRender()) {
      return <Redirect to="/admin/outlets"/>;
    }

    const outlet = this.props.outletFetched ? this.props.outlet : undefined;
    let content;

    switch (this.state.step) {
      default: {
        content = (
          <DelinkForm
            fetched={this.props.fetched}
            handleSubmit={this.handleSubmit}
            onInputChange={this.handleOnInputChange}
            outlets={this.props.outlets}
            selectedOutlet={outlet}
          />
        );
        break;
      }
      case 2: {
        content = this.confirm();
        break;
      }
    }

    return (
      <div className="container-fluid">
        <Title>
          Delink
        </Title>

        {this.props.outletFetching ? (
          <p>
            Loading...
          </p>
        ) : content}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  outlets: state.customer_numbers.outlets,
  fetched: state.customer_numbers.fetched,
  outlet: state.store.outlet,
  outletFetched: state.store.fetched,
  outletFetching: state.store.fetching,
  errors: state.store.errors,
  delink: state.delink
});

export default connect(mapStateToProps)(DelinkPage);



// WEBPACK FOOTER //
// ./src/components/admin/delink/index.jsx